export default __webpack_public_path__ + "static/hypershift_screen_2-e8b21995bc9b6aa3e05a3b8f17ba6273.svg";